import { useNavigate, useParams } from "react-router-dom";
import { ItemRegisterView } from "@/components/ItemRegisterView";

export default function ItemRegisterDetail() {
  const { itemId } = useParams();
  const navigate = useNavigate();
  return (
    <div className="p-8 print:p-4">
      <ItemRegisterView itemId={itemId} onClose={() => navigate("/item-register")} />
    </div>
  );
}
